document.addEventListener('DOMContentLoaded', initTheme);

function initTheme() {
  initMobileMenu();
  initHeroSliders();
}


/* =====================================================
   MOBILE MENU
===================================================== */

function initMobileMenu() {

  const toggle =
    document.querySelector('[data-menu-toggle]');

  const drawer =
    document.querySelector('[data-mobile-drawer]');

  if (
    !toggle ||
    !drawer ||
    toggle.dataset.bound === 'true'
  ) {
    return;
  }

  toggle.dataset.bound = 'true';

  toggle.addEventListener('click', function () {
    drawer.classList.toggle('is-open');
  });
}


/* =====================================================
   HERO SLIDER
===================================================== */

function initHeroSliders() {

  document
    .querySelectorAll('[data-hero-slider]')
    .forEach(function (slider) {

      if (
        slider.dataset.sliderReady === 'true'
      ) {
        return;
      }

      const slides =
        Array.from(
          slider.querySelectorAll(
            '[data-hero-slide]'
          )
        );

      const copySlides =
        Array.from(
          slider.querySelectorAll(
            '[data-hero-copy]'
          )
        );

      const dots =
        Array.from(
          slider.querySelectorAll(
            '[data-hero-dot]'
          )
        );

      const prev =
        slider.querySelector(
          '[data-hero-prev]'
        );

      const next =
        slider.querySelector(
          '[data-hero-next]'
        );

      const media =
        slider.querySelector(
          '.hero-media'
        );

      if (!slides.length) {
        return;
      }

      slider.dataset.sliderReady =
        'true';

      let current = 0;
      let timer = null;

      const autoplay =
        media?.dataset.heroAutoplay === 'true';

      const speed =
        Math.max(
          3000,
          Number(
            media?.dataset.heroSpeed || 5000
          )
        );


      /* =========================================
         SHOW SLIDE
      ========================================= */

      function showSlide(index) {

        current =
          (index + slides.length) %
          slides.length;


        /* IMAGE */

        slides.forEach(
          function (slide, i) {

            slide.classList.toggle(
              'is-active',
              i === current
            );

          }
        );


        /* TEXT */

        copySlides.forEach(
          function (copy, i) {

            const active =
              i === current;

            copy.classList.toggle(
              'is-active',
              active
            );

            copy.style.opacity =
              active ? '1' : '0';

            copy.style.visibility =
              active
                ? 'visible'
                : 'hidden';

            copy.style.pointerEvents =
              active
                ? 'auto'
                : 'none';

          }
        );


        /* DOTS */

        dots.forEach(
          function (dot, i) {

            const active =
              i === current;

            dot.classList.toggle(
              'is-active',
              active
            );

            dot.setAttribute(
              'aria-current',
              active
                ? 'true'
                : 'false'
            );

          }
        );

      }


      /* =========================================
         STOP AUTOPLAY
      ========================================= */

      function stopTimer() {

        if (timer) {

          clearInterval(timer);

          timer = null;

        }

      }


      /* =========================================
         START AUTOPLAY
      ========================================= */

      function startTimer() {

        stopTimer();

        if (
          !autoplay ||
          slides.length < 2
        ) {
          return;
        }

        timer =
          setInterval(
            function () {

              showSlide(
                current + 1
              );

            },
            speed
          );

      }


      /* =========================================
         PREVIOUS
      ========================================= */

      if (prev) {

        prev.addEventListener(
          'click',
          function () {

            showSlide(
              current - 1
            );

            startTimer();

          }
        );

      }


      /* =========================================
         NEXT
      ========================================= */

      if (next) {

        next.addEventListener(
          'click',
          function () {

            showSlide(
              current + 1
            );

            startTimer();

          }
        );

      }


      /* =========================================
         DOTS
      ========================================= */

      dots.forEach(
        function (dot) {

          dot.addEventListener(
            'click',
            function () {

              const index =
                Number(
                  dot.dataset.heroDot
                );

              showSlide(index);

              startTimer();

            }
          );

        }
      );


      /* =========================================
         INITIAL
      ========================================= */

      showSlide(0);

      startTimer();

    });

}


/* =====================================================
   SHOPIFY THEME EDITOR
===================================================== */

document.addEventListener(
  'shopify:section:load',
  function (event) {

    const section =
      event.target;

    if (!section) {
      return;
    }

    initMobileMenu();
    initHeroSliders();

  }
);